import { render, staticRenderFns } from "./ServiceJoinStep3.vue?vue&type=template&id=610951ba&"
import script from "./ServiceJoinStep3.vue?vue&type=script&lang=js&"
export * from "./ServiceJoinStep3.vue?vue&type=script&lang=js&"
import style0 from "./ServiceJoinStep3.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports